import { Component, OnInit } from '@angular/core';
import { AuthService, ConfigService } from '@lciapps/auth';
import { TranslationService } from '@lciapps/lci-core';
import { AppService } from './app.service';
import { CoreService } from './core/core.service';
import { FooterService } from './core/footer-service/footer.service';


@Component({
  selector: 'app-root',
  template: `
  <div class="content">
    <app-header></app-header>
    <router-outlet></router-outlet>
    <div class="push"></div>
  </div>
  <app-footer *ngIf="displayFooter" class="footer"></app-footer>
  <app-loader></app-loader>
    `,
  styles: [
    `
    .content{
  min-height: 100%;
  margin: 0 auto -114px;
}
.push,.footer{
  height:114px;
}
.footer {
  float: left;
  width: 100%;
}
    `
  ]
})
export class AppComponent implements OnInit {
  loggedIn = false;
  translations: any = [];
  locale: string = 'en';
  displayFooter = true;
  constructor(
    private authService: AuthService,
    private translationService: TranslationService,
    private configService: ConfigService,
    private coreService: CoreService,
    private appService: AppService,
    private footerService: FooterService) {

    this.loadTranslations();
    this.runAuthCheck();
    this.setCustomHeaders();
  }

  public ngOnInit() {
    this.coreService.getBrowserLocale().subscribe(locale => {
      this.locale = locale;
      this.translationService.setLocale(locale).subscribe();
    });
    this.footerService.getFooterType.subscribe((data) => {
      if (data === 'hideFooter') {
        this.displayFooter = false;
      }
    })
    //this.appService.getZendeskUrl().subscribe();
  }

  private loadTranslations() {
    this.translationService.loadTranslations().subscribe();
  }

  private runAuthCheck() {
    this.authService.loggedIn$.subscribe(loggedin => {
      this.loggedIn = loggedin;
    });
  }

  public signout() {
    this.authService.startSignoutMainWindow();
  }

  private setCustomHeaders() {
    const headers = {
      Language: () => {
        return this.locale;
      }
    };
    this.configService.setInterceptorHeaders('apiurl://', headers);
    this.configService.setInterceptorHeaders('authurl://', headers);
  }

}
